module.exports = __webpack_public_path__ + "static/media/back_4.ec5c449f.png";